import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  SolutionsList
} from '../../components'
import Styles from './Solutions.css'

@CSSModules(Styles, {allowMultiple:true})
export default class Solutions extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'The solutions',
      description: 'Retirement plans should offer sustainable investing options to all plan participants. Making the default investment option sustainable is the best way to protect people from the financial risks of unsustainable investments.',
      url: config.domain + config.routes.solutions
    }
  }

  render() {
    return (
      <div styleName='page'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <ContainerDivs>
          <h1 styleName='large-page-title'>
            {this.state.title}
          </h1>
          <div styleName='content'>
            <p>
              Employees who put away a portion of their hard-earned paycheck for retirement need sustainable investing options. It is the responsibility of every company to ensure that the retirement plan offers sustainable investments. The problem is that the default option, which is rarely sustainable, is the simplest to join so most people opt-in without fully understanding that this means that their money is being invested into risk sectors like fossil fuels, deforestation, prisons, and weapons.
            </p>
            <SolutionsList />
          </div>
        </ContainerDivs>
        <br/>
        <br/>
        <br/>
      </div>
    )
  }
}